<template>
	<span
		:class="classes"
		@click="onClick"
	>
		<span v-if="hasSlot(`icon`)" class="teaming-chip__icon">
			<slot name="icon"></slot>
		</span>
		<span class="teaming-chip__text" v-if="!!(text || hasSlot(`text`))">
			<slot name="text">{{ text }}</slot>
		</span>
	</span>
</template>

<script>
export default {
	name: "TeamingChip",
	emits: [ "click", ],
	props: {
		className: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"teaming-chip": true,
				[ this.className ]: !!this.className,
			};
		},
	},
	methods: {
		hasSlot( slotName ) {
			return !!( this.$slots[ slotName ] );
		},
		onClick( event ) {
			event.preventDefault();
			event.stopPropagation();
			this.$emit( "click", event );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-chip {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 0.125rem 0.375rem;
	border-radius: .25rem;
	font-style: normal;
	font-weight: 500;
	@include font-and-line-for(-1);
}

.teaming-chip__icon {
	text-align: center;
	margin-right: 0.25rem;
}
</style>
